import React, { Component } from 'react'

import PersonalDetailsStep from './PersonalDetailsStep'

import Http from '../shared/http'

const STEPS = [PersonalDetailsStep]

export default class RegistrationWizard extends Component {
  static propTypes = {}

  constructor(props) {
    super(props)
    this.state = {
      currentStep: 0,
      formData: props.formData,
      tenant: props.tenant,
      identificationTypes: props.identificationTypes,
      titleOptions: props.titleOptions
    }
  }

  onBackClicked = data => {
    this.setState(state => {
      if (this.isFirstStep(state)) {
        return
      };
      const previousStep = state.currentStep - 1
      return {
        currentStep: previousStep,
        formData: Object.assign({}, state.formData, data)
      }
    })
  }

  onNextClicked = data => {
    this.setState(state => {
      if (this.isLastStep(state)) {
        this.onLastStepSubmitted(Object.assign({}, state.formData, data))
        return
      };
      const nextStep = state.currentStep + 1
      return {
        currentStep: nextStep,
        formData: Object.assign({}, state.formData, data)
      }
    })
  }

  isLastStep(state = this.state) {
    return state.currentStep == STEPS.length - 1
  }

  isFirstStep(state = this.state) {
    return state.currentStep == 0
  }

  onLastStepSubmitted(formData) {
    Http.request(`/registration/create`, 'POST', JSON.stringify(formData)).then(function (response) {
      if (response.ok) {
        window.location = `/registration/success`
      }
    }, function (error) {
      // What should be done on request error?
      console.error(error.message)
    }).catch(function (error) {
      // What should be done on network failure or error?
      console.error(error)
    })
  }

  getCurrentStepComponent() {
    return STEPS[this.state.currentStep]
  }

  render() {
    const CurrentStep = this.getCurrentStepComponent()
    return (
      <div className='card__right card--registration__form'>
        <CurrentStep onNextClicked={this.onNextClicked}
          onBackClicked={this.onBackClicked}
          formData={this.state.formData}
          identificationTypes={this.props.identificationTypes}
          titleOptions={this.props.titleOptions} />
      </div>
    )
  }
}
